import React, { useState, useEffect, useContext } from 'react';
// import { Link } from 'react-router-dom';
import api from '../../service/api';
import {
  Paper, Tooltip, IconButton, Button,
  Stack,
  Alert,
  Box,
  Typography,
  Grid
} from '@mui/material';
import ProgressBar from '../progress/progressBar';
import HomeIcon from '@mui/icons-material/Home';
// import CONSTANT from '../../Constant/Constant';
// import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import { useHistory } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import TextField from '@mui/material/TextField';
import './style.css';
// import SearchIcon from '@mui/icons-material/Search';
import { DirectionContext } from '../../context/DirectionProvider';
import NoMatchConfirm from './NoMatchConfirm';
import AccordionTransition from './AccordianSection';

const ViewNoMatch = (props) => {
  const id = props?.match?.params?.id
  // const history = useHistory();
  const [progressFlag, setProgressFlag] = useState(true);
  const [noMatchConfirmOpen, setNoMatchConfirmOpen] = useState(false);
  const [matchAction, setMatchAction] = useState('accept');
  const [data, setData] = useState(null);
  const direction = useContext(DirectionContext);

  const goToHome = () => {
    props.history.push('/');
  }

  const goBack = () => {
    props.history.goBack();
  };

  useEffect(() => {
    fetchData(id)
  }, [id]);

  function fetchData(id) {
    // if (localStorage.getItem("data")) {
    //   setProgressFlag(false)
    //   return setData(JSON.parse(localStorage.getItem("data")))
    // }
    api
      .viewNoMatchById(id)
      .then(response => {
        setData(response.data)
      })
      .catch(error => {
        console.log("Error in fetch api", error)
      })
      .finally(() => setProgressFlag(false))
  };

  // const getSafelyFromEntity = (key) => {
  //   const val = data?.request_body?.updatedValue?.entity?.[key] ?? null
  //   if (val && Array.isArray(val) && val[0].value) {
  //     return val[0].value
  //   }
  //   return null
  // }

  // const getSafelyFromEntityAddress = (key) => {
  //   if (!data?.request_body?.updatedValue?.entity?.Address || !Array.isArray(data?.request_body?.updatedValue?.entity?.Address)) {
  //     return null
  //   }
  //   const val = data.request_body.updatedValue.entity.Address[0][key] ?? null
  //   if (val && Array.isArray(val) && val[0].value) {
  //     return val[0].value
  //   }
  //   return null
  // }

  // const getAllSpecialties = () => {
  //   /*
  //   "NewSpecialities": {
  //       "OtherSpecialty": [
  //           {
  //               "value": [
  //                   "Accident / Trauma Surgery, Sport Traumatology | ATSST | ATSST"
  //               ]
  //           }
  //       ],
  //       "PrimarySpecialty": [
  //           {
  //               "value": "Abdominal Surgery | AS | AS"
  //           }
  //       ]
  //   },
  //   */
  //   const obj = data?.request_body?.updatedValue?.entity?.NewSpecialities
  //   const specialties = []
  //   if (obj && obj.PrimarySpecialty && Array.isArray(obj.PrimarySpecialty)) {
  //     specialties.push(obj.PrimarySpecialty[0].value)
  //   }

  //   if (obj && obj.OtherSpecialty && Array.isArray(obj.OtherSpecialty)) {
  //     specialties.push(...obj.OtherSpecialty[0].value[0].split(","))
  //   }

  //   return specialties.length ? specialties : []
  // }

  // const getAllIdentifiers = () => {
  //   const obj = data?.request_body?.updatedValue?.entity?.NewIdentifiers

  //   if (!obj || !obj.length) {
  //     return []
  //   }
  //   const items = []
  //   for (var item of obj) {
  //     if (item && item.ID && item.ID[0].value && item.Type && item.Type[0].value) {
  //       items.push({
  //         type: item.Type[0].value.split("|")[0].trim(),
  //         value: item.ID[0].value
  //       })
  //       // items.push(`${item.Type[0].value}: ${item.ID[0].value}`)
  //     }
  //   }
  //   return items
  // }

  // const entity = data?.request_body?.updatedValue?.entity ?? {}
  const eph_profile = data?.eph_profile ?? null

  if (eph_profile) {
    const identifiers = []
    if (eph_profile.attributes.Identifiers) {
      eph_profile.attributes.Identifiers.sort((a, b) => a.label.localeCompare(b.label)).map(item => {
        identifiers.push(item.label)
        return item
      })
    }
    eph_profile.attributes.displayIdentifiers = [{ value: identifiers.join("\r\n") }]

    const specialties = []
    if (eph_profile.attributes.Specialities) {
      eph_profile.attributes.Specialities.sort((a, b) => a.label.localeCompare(b.label)).map(item => {
        specialties.push(item.label)
        return item
      })
    }
    eph_profile.attributes.displaySpecialties = [{ value: specialties.join("\r\n") }]
    // return eph_profile
  }

  const displayAttributes = [
    {
      "key": "FirstName",
      "label": "First Name"
    },
    {
      "key": "MiddleName",
      "label": "Middle Name"
    },
    {
      "key": "LastName",
      "label": "Last Name"
    },
    {
      "key": "Title",
      "label": "Title"
    },
    {
      "key": "ClassificationCode",
      "label": "Classification Code"
    },
    {
      "key": "ActiveFlag",
      "label": "Active Flag"
    },
    {
      "key": "EffectiveStartDate",
      "label": "Effective Start Date"
    },
    {
      "key": "EffectiveEndDate",
      "label": "Effective End Date"
    },
    {
      "key": "displayIdentifiers",
      "label": "Identifiers"
    },
    {
      "key": "displaySpecialties",
      "label": "Specialties"
    }
  ]

  let selected_profile_reference_id = 'New!'
  if (data && data.eph_profiles && Array.isArray(data.eph_profiles) && data.selected_profile !== '') {
    const item = data.eph_profiles.find(item => item.uri.indexOf(data.selected_profile))
    if (item) {
      selected_profile_reference_id = item.attributes.HCPReferenceId[0].value
    }
  }

  const relationsInfo = []
  if (data && data?.request_body?.updatedValue?.relations && data?.request_body?.updatedValue?.relations[0]) {
    const relation = data.request_body.updatedValue.relations[0]
    const relationInfo = {}

    if (relation.uri) {
      relationInfo["Entity URI"] = relation.uri
    }
    if (relation.label) {
      relationInfo["HCO Name"] = relation.label
    }
    if (relation.Name && relation.Name[0] && relation.Name[0].value) {
      relationInfo["HCO Name"] = relation.Name[0].value
    }
    if (relation.Rank && relation.Rank[0] && relation.Rank[0].value) {
      relationInfo["Rank"] = relation.Rank[0].value
    }
    if (relation.EffectiveStartDate && relation.EffectiveStartDate[0] && relation.EffectiveStartDate[0].value) {
      relationInfo["Effective Start Date"] = relation.EffectiveStartDate[0].value
    }
    if (relation.EffectiveEndDate && relation.EffectiveEndDate[0] && relation.EffectiveEndDate[0].value) {
      relationInfo["Effective End Date"] = relation.EffectiveEndDate[0].value
    }
    if (relation.ClassificationCode && relation.ClassificationCode[0] && relation.ClassificationCode[0].value) {
      relationInfo["Classification Code"] = relation.ClassificationCode[0].value
    }
    if (relation.Address && Array.isArray(relation.Address) && relation.Address[0]) {
      if (relation.Address[0].AddressLine1 && relation.Address[0].AddressLine1 && relation.Address[0].AddressLine1[0] && relation.Address[0].AddressLine1[0].value) {
        relationInfo["Address Line 1"] = relation.Address[0].AddressLine1[0].value
      }
      if (relation.Address[0].City && relation.Address[0].City && relation.Address[0].City[0] && relation.Address[0].City[0].value) {
        relationInfo["City"] = relation.Address[0].City[0].value
      }
      if (relation.Address[0].StateProvince && relation.Address[0].StateProvince && relation.Address[0].StateProvince[0] && relation.Address[0].StateProvince[0].value) {
        relationInfo["State/Province"] = relation.Address[0].StateProvince[0].value
      }
      if (relation.Address[0].Zip && relation.Address[0].Zip && relation.Address[0].Zip[0] && relation.Address[0].Zip[0].value) {
        relationInfo["Zip"] = relation.Address[0].Zip[0].value
      }
    }

    relationsInfo.push(relationInfo)
  }

  return (
    <React.Fragment>
      <section className={"container body-height extra-margin-top-less view-potential"}>
        {
          progressFlag
          &&
          <div className="d-flex justify-content-center extra-margin-top">
            <ProgressBar />
          </div>
        }
        {
          !progressFlag &&
          <>
            <Paper square className='mb-2'>
              <Stack direction={'row'} gap={0} justifyContent={'space-between'} alignItems={'center'}>
                <div className="tabdata">
                  <ul className="nav">
                    <li id="track-head"
                      className={`active _wg-exclude`}>
                      Review No Match
                    </li>
                  </ul>
                </div>
                <Stack direction={'row'} gap={1}>
                  <Tooltip disableFocusListener title="Back" id="tooltip">
                    <IconButton aria-label="back"
                      className="text-danger float-end"
                      onClick={goBack} color="secondary">
                      <ArrowBackIcon sx={{ transform: direction === 'rtl' ? 'rotate(180deg)' : '' }} />
                    </IconButton>
                  </Tooltip>
                  <IconButton aria-label="home" onClick={goToHome} className=' float-end'
                    color="secondary">
                    <Tooltip disableFocusListener title="Return To Home" id="tooltip">
                      <HomeIcon className="text-danger "
                      />
                    </Tooltip>
                  </IconButton>
                </Stack>
              </Stack>
            </Paper>
            <div className="outlet">

              {eph_profile && <>
                <Typography variant="h6" gutterBottom component="div">Veeva Network Profile</Typography>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell component="th" className='attributes_label'>Reference ID</TableCell>
                        <TableCell component="th" className={{ attributes_label: true }}>
                          {eph_profile.attributes.HCPReferenceId[0].value}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {displayAttributes.map((attr, index) => (
                        <TableRow key={index}>
                          <TableCell className={'attributes_label'}>
                            {attr.label}
                          </TableCell>
                          <TableCell
                            key={index}
                            className={{ 'attributes_value': true }}>
                            {eph_profile.attributes[attr.key] ? eph_profile.attributes[attr.key][0].value : ' - '}
                          </TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer></>}

              <div><br /></div>


              {/* Show error message if no profiles returned from eph api */}
              {!eph_profile && <>
                <Alert severity="error">
                  Error fetching matching profiles details from EPH for Entity URI: {data?.hcp_uri}<br />
                </Alert>
              </>}

              <Typography variant="h6" gutterBottom component="div">Affiliation</Typography>
              {relationsInfo.length > 0 && <div className='hr-at-end'>
                {relationsInfo.map((relationInfo, index) => {
                  let heading = ""
                  let profile_count = 0
                  if (data && data.hcp_affiliations_count_by_hco && data.hcp_affiliations_count_by_hco[relationInfo["Entity URI"]]) {
                    profile_count = data.hcp_affiliations_count_by_hco[relationInfo["Entity URI"]]
                  }
                  heading = `HCO to HCP Relationships: ${profile_count}`

                  let eph_profiles = null

                  if (data && data.hcp_affiliations_by_hco && data.hcp_affiliations_by_hco[relationInfo["Entity URI"]]) {
                    eph_profiles = data.hcp_affiliations_by_hco[relationInfo["Entity URI"]]

                    eph_profiles.map(profile => {
                      const identifiers = []
                      if (profile.attributes.Identifiers) {
                        profile.attributes.Identifiers.sort((a, b) => a.label.localeCompare(b.label)).map(item => {
                          identifiers.push(item.label)
                          return item
                        })
                      }
                      profile.attributes.displayIdentifiers = [{ value: identifiers.join("\r\n") }]

                      const specialties = []
                      if (profile.attributes.Specialities) {
                        profile.attributes.Specialities.sort((a, b) => a.label.localeCompare(b.label)).map(item => {
                          specialties.push(item.label)
                          return item
                        })
                      }
                      profile.attributes.displaySpecialties = [{ value: specialties.join("\r\n") }]
                      return profile
                    })
                  }

                  return (<div key={index}>
                    <b>Affiliation {index + 1}</b>  <br />
                    {Object.keys(relationInfo).map(label => <div>
                      <b>{label}: </b>{relationInfo[label]}
                    </div>)}

                    {profile_count > 50 && <><Typography component="div">50+ affiliations found. Unable to load all affiliations in ECS, please use EPH to view the same</Typography></>}

                    {Array.isArray(eph_profiles) && eph_profiles.length > 0 && <AccordionTransition heading={heading}>
                      <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell component="th" className='attributes_label'>Reference ID</TableCell>
                              {eph_profiles.map((profile, index) => <TableCell component="th" key={index} className={{ attributes_label: true }}>
                                {profile.attributes.HCPReferenceId[0].value}
                              </TableCell>)}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {displayAttributes.map((attr, index) => (
                              <TableRow key={index}>
                                <TableCell className={'attributes_label'}>
                                  {attr.label}
                                </TableCell>
                                {eph_profiles.map((profile, index) => <TableCell
                                  key={index}
                                  className={{ 'attributes_value': true }}>
                                  {profile.attributes[attr.key] ? profile.attributes[attr.key][0].value : ' - '}
                                </TableCell>)}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionTransition>}
                  </div>)
                })}
              </div>}

              <div><br /></div>


              {data.review_status != "Pending" && <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
                <Alert severity="success">
                  Review Status: {data.review_status} <br />
                  Review completed on {data.updated_at} <br />
                  Review by {data.updated_by}<br />
                  Review Comment: {data.review_comment}
                </Alert>
              </Box>}

              {eph_profile && data.review_status == "Pending" && <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
                <Grid container style={{ maxWidth: 200 }} direction="row" alignItems="center" justifyContent="center" spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => {
                        setMatchAction('accept')
                        setNoMatchConfirmOpen(true)
                      }}>Accept</Button>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => {
                        setMatchAction('reject')
                        setNoMatchConfirmOpen(true)
                      }}>Reject</Button>
                  </Grid>
                </Grid>
              </Box>}

              {/* <pre>{JSON.stringify(eph_profiles, null, 4)}</pre> */}

            </div>
          </>
        }
      </section>

      <NoMatchConfirm
        data={data}
        action={matchAction}
        open={noMatchConfirmOpen}
        onClose={() => {
          setNoMatchConfirmOpen(false)
          // refresh api response
          fetchData(id)
        }} />

    </React.Fragment>
  );
};



export default ViewNoMatch;
